import React from 'react'
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import image1 from '../images/valuation.jpg'
import image2 from '../images/development and rent brokage.jpg'
import image3 from '../images/property management.jpg'
import image4 from '../images/real estate agency.jpg'
import './whatweoffer.css'
const Whatweoffer = () => {
  return (
    <div className='container offercontainer'>
        <h1 className='offerheading'>What We Offer</h1>
        <div className='inneroffercontainer'>
            <article>
                 <Card className='card-edit' style={{ width: '16rem' }}>
                    <Card.Img variant="top" src={image1} />
                    <Card.Body>
                        <Button className='card-btn-edit' variant="primary">Valuation</Button>
                    </Card.Body>
                </Card>
            </article>
             <article>
                 <Card className='card-edit' style={{ width: '16rem' }}>
                    <Card.Img variant="top" src={image4} />
                    <Card.Body>
                        <Button className='card-btn-edit' variant="primary">Real Estate Agency</Button>
                    </Card.Body>
                </Card>
            </article>
             <article>
                 <Card className='card-edit' style={{ width: '16rem' }}>
                    <Card.Img variant="top" src={image3} />
                    <Card.Body>
                        <Button className='card-btn-edit' variant="primary">Property management</Button>
                    </Card.Body>
                </Card>
            </article>
             <article>
                 <Card className='card-edit' style={{ width: '16rem' }}>
                    <Card.Img variant="top" src={image2} />
                    <Card.Body>
                        <Button className='card-btn-edit' variant="primary">Development and rent finance brokeage</Button>
                    </Card.Body>
                </Card>
            </article>
        </div>
    </div>
  )
}

export default Whatweoffer